<template>
  <HeaderBase>
    <div
      class="flex items-center shrink header-title w-2/5 cursor-pointer"
      @click="$router.push({
        name: 'partners',
      })">
      <span class="arrow arrow-l arrow-primary"></span>
      <template v-if="partner">
        <b>Редактировать реферрала: {{ partner.name }}</b>
      </template>
      <template v-else>
        <b>Редактировать реферрала</b>
      </template>
    </div>
    <div class="shrink flex-container flex-dir-row align-center">
    </div>
  </HeaderBase>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
  computed: {
    ...mapGetters({
      getPartnerById: 'partners/getPartnerById',
    }),
    partnerId() {
      return this.$route.params.id;
    },
    partner() {
      return this.getPartnerById(this.partnerId);
    },
  },
};
</script>
